export const COOKIE_CONSENT_STORAGE_KEY = "cookieConsent";
export const COOKIE_CONSENT_VERSION = "2026-01-01";

export const COOKIE_CATEGORIES = [
  "necessary",
  "preferences",
  "analytics",
  "marketing",
];

export function createDefaultConsent() {
  return {
    // Necessary cookies include essential functionality such as payments (Stripe).
    necessary: true,
    preferences: false,
    analytics: false,
    marketing: false,
  };
}

export function normalizeConsent(consent) {
  const base = createDefaultConsent();
  if (!consent || typeof consent !== "object") return base;

  return {
    necessary: true,
    preferences: Boolean(consent.preferences),
    analytics: Boolean(consent.analytics),
    marketing: Boolean(consent.marketing),
  };
}

export function readStoredCookieConsent() {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;

    return {
      version: typeof parsed.version === "string" ? parsed.version : null,
      updatedAt: typeof parsed.updatedAt === "string" ? parsed.updatedAt : null,
      consent: normalizeConsent(parsed.consent),
    };
  } catch {
    return null;
  }
}

export function writeStoredCookieConsent(consent) {
  const record = {
    version: COOKIE_CONSENT_VERSION,
    updatedAt: new Date().toISOString(),
    consent: normalizeConsent(consent),
  };

  try {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(record));
  } catch {
    // Ignore storage errors (private mode, blocked storage, etc.)
  }

  return record;
}

export function shouldShowConsentBanner(storedRecord) {
  return !storedRecord || storedRecord.version !== COOKIE_CONSENT_VERSION;
}

export function canLoad(consent, category) {
  if (category === "necessary") return true;

  const normalized = normalizeConsent(consent);

  // If analytics/marketing scripts are added later, they must only load after explicit consent.
  if (category === "preferences") return normalized.preferences;
  if (category === "analytics") return normalized.analytics;
  if (category === "marketing") return normalized.marketing;

  return false;
}
